import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { OnboardingProvider } from '../../context';
import { useInitializeSteps } from '../../hooks/useInitializeSteps';
import { useProxyWizard } from '../../hooks/useProxyWizard';

import { layoutDataDefault, layoutSteps, layoutStepsKeys } from './constants';
import { LayoutDataType } from './types';

const LayoutOwnAI_Pool: React.FC = () => {
  const { proxyWizard, step } = useProxyWizard(layoutStepsKeys, layoutSteps);

  useInitializeSteps(proxyWizard, layoutStepsKeys);

  const form = useForm<LayoutDataType>({
    defaultValues: layoutDataDefault,
    values: layoutDataDefault,
  });

  const StepComponent = layoutSteps[step as keyof typeof layoutSteps].component;

  return (
    <OnboardingProvider wizard={proxyWizard} steps={layoutSteps}>
      <FormProvider {...form}>
        <StepComponent />
      </FormProvider>
    </OnboardingProvider>
  );
};

export default LayoutOwnAI_Pool;
